function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import Radio from '../Radio';
/**
 * The RadioGroup component groups several Radio inputs together creating a
 * choice set and makes it clearer what Radios are related. This radio group is implemented as a
 * controlled component which means that state is managed outside of the component.
 *
 * - [React controlled inputs](https://reactjs.org/docs/forms.html#controlled-components)
 * - [MDN docs for radio](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/radio)
 *
 * ## Related Components
 * - [Checkbox](../Checkbox/README.md)
 * - [Radio](../Radio/README.md)
 *
 * ## Usage
 *
 * See `Radio` for usage examples.
 *
 * ## Props
 */

var RadioGroup = /*#__PURE__*/function (_PureComponent) {
  _inherits(RadioGroup, _PureComponent);

  var _super = _createSuper(RadioGroup);

  function RadioGroup() {
    var _this;

    _classCallCheck(this, RadioGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "isSelected", function (value) {
      var selectedValue = _this.props.value;
      return value === selectedValue;
    });

    _defineProperty(_assertThisInitialized(_this), "wrapRadios", function (children) {
      var _this$props = _this.props,
          autoFocusOnSelectedChild = _this$props.autoFocusOnSelectedChild,
          name = _this$props.name,
          variant = _this$props.variant,
          _onChange = _this$props.onChange,
          value = _this$props.value;
      return Children.toArray(children).map(function (el) {
        if (el.type === Radio) {
          var isChecked = _this.isSelected(el.props.value);

          return /*#__PURE__*/cloneElement(el, {
            autoFocusOnSelected: autoFocusOnSelectedChild,
            variant: variant || el.props.variant,
            name: name,
            checked: value != null ? isChecked : el.props.checked,
            onChange: function onChange(e) {
              var childOnChange = el.props.onChange;
              if (typeof childOnChange === 'function') childOnChange(e);
              if (typeof _onChange === 'function') _onChange(e);
            },
            children: typeof el.props.children === 'function' ? el.props.children(isChecked) : el.props.children
          });
        }

        if (typeof el === 'string') return el;
        return /*#__PURE__*/cloneElement(el, {
          children: _this.wrapRadios(el.props.children)
        });
      });
    });

    return _this;
  }

  _createClass(RadioGroup, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          children = _this$props2.children,
          qa = _this$props2.qa;
      var radios = this.wrapRadios(children);
      return /*#__PURE__*/React.createElement("span", {
        className: "psw-radio-group ".concat(className),
        "data-qa": qa
      }, radios);
    }
  }]);

  return RadioGroup;
}(PureComponent);

RadioGroup.defaultProps = {
  qa: '',
  autoFocusOnSelectedChild: false,
  className: '',
  name: '',
  children: null,
  onChange: function onChange() {},
  variant: '',
  value: null
};
RadioGroup.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Automatically focus on the selected radio when it is selected
   */
  autoFocusOnSelectedChild: PropTypes.bool,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * Presentational variants
   */
  variant: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf(['content', 'toggle', 'standard'])]),

  /**
   * Connects all children Radio components
   */
  name: PropTypes.string,

  /**
   * The selected value
   */
  value: PropTypes.string,

  /**
   * Should be an array of Radio components
   */
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),

  /**
   * event callback to be called when the checked state changes
   */
  onChange: PropTypes.func
};
export default RadioGroup;